// services/mappers/droneNest.js
import { CheckValue } from "../service";
import { setFloors } from "./floor";
import { setDrone } from "./drone";
import { setDoor } from "./door";

export const setDroneNest = (drone_nest = {}) => ({
  createdAt: drone_nest?.CreatedAt || null,
  updatedAt: drone_nest?.UpdatedAt || null,
  deletedAt: drone_nest?.DeletedAt || null,
  id: drone_nest?.ID || null,
  created_by_id: drone_nest?.created_by_id || null,
  campus_id: drone_nest?.campus_id || null,
  floor_id: drone_nest?.floor_id || null,
  display_id: drone_nest?.display_id || null,
  base_station_ip: drone_nest?.base_station_ip || null,
  name: drone_nest?.name || null,
  latitude: drone_nest?.latitude || null,
  longitude: drone_nest?.longitude || null,
  notes: drone_nest?.notes || null,
  state: drone_nest?.state || null,
  power: drone_nest?.power || null,
  floor: setFloors({}),
  drones: CheckValue(drone_nest?.drones) ? drone_nest.drones.map(setDrone) : [],
  doors: setDoor(drone_nest?.door ?? {}),
});
